import * as Sentry from '@sentry/react';
import { environment } from './environment';

export const initSentry = () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  Sentry.init({
    dsn: 'https://223bd8ed778f453b98f9c42d68e99170@o123606.ingest.us.sentry.io/1534214',
    environment: `${environment.env}-${environment.region}` || 'development',
    sendDefaultPii: true,
    release: _GIT_HASH_ || (process.env.NODE_ENV === 'development' ? 'development' : 'unknown'),
  });
  Sentry.setTag('app', 'reportingV2');
};

export const setSentryUserContext = (userInfo: any) => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  Sentry.setUser({
    id: userInfo.userId,
    email: userInfo.email,
    username: userInfo.firstName + ' ' + userInfo.lastName,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
    countryCode: userInfo.countryCode,
  });
};

export const setSentryContext = (key: string, context: any) => {
  Sentry.setContext(key, context);
};

export const captureErrorWithContext = (error: Error, context?: any) => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext('errorContext', context);
    }
    scope.setLevel('error');
    Sentry.captureException(error);
  });
};
